<template>
  <div class="wrapper" @mouseleave="handleLabelClick" @click="navigateToLink">
    <h4 class="label" @mouseover="handleLabelClick">
      {{ row.label }}
    </h4>
    <p class="subLabel">{{ row.subLabel }}</p>
    <el-card
      class="box-card card_wrapper"
      v-if="isModalVisbible && row.data && row.data.length > 0"
    >
      <li
        v-for="item in row.data"
        :key="item.id"
        class="item"
        @click="navigateToLink"
      >
        <span>{{ item.label }}</span>
      </li>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "SubHeadingFormatter",
  props: ["row", "showModal"],
  data() {
    return {
      isModalVisbible: false,
    };
  },
  methods: {
    handleLabelClick() {
      this.isModalVisbible = !this.isModalVisbible;
    },
    navigateToLink() {
      if (this.row.redirectPath) {
        this.$router.push({ path: this.row.redirectPath });
      }
    },
  },
};
</script>

<style scoped>
.label {
  text-decoration: underline;
  font-size: 14px;
  line-height: 12px;
}

.subLabel {
  font-size: 12px;
  color: #828282;
}

.wrapper {
  width: 300px;
  height: 100%;
}

.card_wrapper {
  position: absolute;
  width: 250px;
  z-index: 1000;
  left: -230%;
  top: -100%;
  height: 130px;
  overflow: auto;
  padding-top: 0px;
}

.item {
  font-weight: 400;
  font-size: 14px;
  line-height: 28px;
  color: #525252;
  cursor: pointer;
}

.item:hover {
  background: rgb(0, 255, 242);
}
</style>
